import { useState } from "react";
import ButtonLoader from "../ButtonLoader";

const PartnerAdminForm = ({ isLoading, onSubmit, onClose, }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      fullName: name,
      email
    });
  };

  return (
    <form
      className="flex flex-col gap-2"
      onSubmit={handleSubmit}
    >
      <input
        type="text"
        className="!h-[38px] py-1 text-sm"
        value={name}
        placeholder="Name"
        onChange={(e) => setName(e.target.value)}
      />

      <input
        type="email"
        className="!h-[38px] py-1 text-sm"
        value={email}
        placeholder="Email"
        onChange={(e) => setEmail(e.target.value)}
      />

      <div className="flex items-center gap-2 mt-2">
        <button
          className="ase-button-primary px-2 py-1 text-sm"
        >
          {isLoading ? <ButtonLoader /> : "Invite"}
        </button>

        <button
          className="ase-button-secondary px-2 py-1 text-sm text-red-600"
          onClick={() => onClose(false)}
        >
          Cancel
        </button>
      </div>
    </form>
  )
}

export default PartnerAdminForm;
